'use strict';

define('vb/extensions/dynamic/private/models/context/layoutResourceExtensionContext',[
  'vb/private/stateManagement/context/containerExtensionContext',
  'vb/extensions/dynamic/private/models/context/layoutResourceExtensionBaseContext',
], (
  ContainerExtensionContext,
  LayoutResourceExtensionBaseContext,
) => {
  /**
   * Context object for a LayoutResourceExtension, e.g., data-description-x,
   * field-templates-x, metadata-rules-x, etc.
   */
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore TS2417 - generated ESM typecheck rejects the intentionally narrower translations-only base context.
  class LayoutResourceExtensionContext extends ContainerExtensionContext {
    /**
     * BaseContextType property: The type of the baseContext object used for $base in an expression.
     * This is used by super class ContainerContext to construct the baseContext object.
     *
     * It _ONLY_ exposes translations.
     */
    static get BaseContextType() {
      return LayoutResourceExtensionBaseContext;
    }

    /**
     * @param {Object} layoutResourceExtension
     * @returns {Object}
     */
    static getAvailableContexts(layoutResourceExtension) {
      const availableContexts = super.getAvailableContexts(layoutResourceExtension);
      const filteredContexts = {};

      // Expose just modules and translations bundles for all layout resources.
      // We don't want a layout to have access to it's parent container's variables.
      // Otherwise, you can't embed it in any arbitrary container.
      ['$functions', '$modules', '$translations'].forEach((key) => {
        const propDesc = Object.getOwnPropertyDescriptor(availableContexts, key);

        Object.defineProperty(filteredContexts, key, propDesc);
      });

      // Expose baseContext.translations, for base resource's $translations
      // LayoutResourceExtension only exposes $functions,$modules,$translations in its available contexts.
      // To support expression (and metadata) references to the base LayoutResource's translations, need
      // to also expose $base.translations in its available contexts.
      // See https://confluence.oraclecorp.com/confluence/display/ABCS/VB+Business+Rule+Translations
      const { baseContext } = layoutResourceExtension.expressionContext;
      Object.defineProperty(filteredContexts, '$base', {
        configurable: true,
        enumerable: true,
        get() {
          return baseContext;
        },
      });

      return filteredContexts;
    }
  }

  return LayoutResourceExtensionContext;
});

